module.exports = __webpack_public_path__ + "carousel_05_img_03.png?1fe43604829408ceb09f9d78a5163ddf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_05_img_03.png
// module id = 164
// module chunks = 0